import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import BannerMessageService from "../services/BannerMessageService";

const useBannerMessageService = () => {
  const { client } = useApiContext();

  const service = useMemo(() => {
    return new BannerMessageService(client);
  }, [client]);

  return service;
};

export default useBannerMessageService;
